
import React, { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';

interface ProcurementActivityLogProps {
  procurementId: string;
}

export function ProcurementActivityLog({ procurementId }: ProcurementActivityLogProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [activities, setActivities] = useState<any[]>([]);

  useEffect(() => {
    // Simulate loading activity data
    const timer = setTimeout(() => {
      setIsLoading(false);
      // This would be replaced with actual data fetching
      setActivities([]);
    }, 1000);
    
    return () => clearTimeout(timer);
  }, [procurementId]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-8">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (activities.length === 0) {
    return (
      <div className="text-center p-8">
        <p className="text-muted-foreground">No activity has been recorded for this procurement yet.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {activities.map((activity, index) => (
        <div key={index} className="border-l-2 border-muted pl-4 py-2">
          <p className="text-sm">{activity.description}</p>
          <p className="text-xs text-muted-foreground">{activity.date}</p>
        </div>
      ))}
    </div>
  );
}
